import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Modal header with title, close button, and resource-type tab row. */
export function ModalHeader(_ref) {
  var activeTab = _ref.activeTab,
    tabs = _ref.tabs,
    onClose = _ref.onClose,
    onTabChange = _ref.onTabChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-sds-base-default rounded-t-sds-400"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 border-b border-sds-base-default"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-style-heading-main text-sds-base-default"
  }, t("label.link_patient_records", {
    defaultValue: "Link patient records"
  })), /*#__PURE__*/React.createElement("button", {
    "data-testid": "link-records-modal-close",
    "aria-label": t("close", {
      defaultValue: "Close"
    }),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LINK_RECORDS_MODAL_CLOSE);
      onClose();
    },
    className: "w-8 h-8 flex items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-base-secondary transition-colors"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    className: "w-6 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex border-b border-sds-base-default"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement("button", {
      key: tab.id,
      "data-testid": "link-records-tab-".concat(tab.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.LINK_RECORDS_TAB, {
          tabId: tab.id
        });
        onTabChange(tab.id);
      },
      className: "flex-1 flex items-center justify-center gap-1 h-12 text-style-body-small-strong transition-colors ".concat(activeTab === tab.id ? "border-b-2 border-sds-brand-default text-sds-brand-default bg-sds-brand-tertiary" : "border-b-2 border-transparent text-sds-base-secondary hover:bg-sds-base-secondary")
    }, /*#__PURE__*/React.createElement("span", null, tab.label), /*#__PURE__*/React.createElement("span", {
      className: "text-sds-base-tertiary"
    }, "(", tab.count, ")"));
  })));
}